export function addDaysToDate(date: Date, days: number): Date {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    throw new Error("Invalid date provided.");
  }

  const newDate = new Date(date);
  newDate.setDate(date.getDate() + days);

  return newDate;
}

export const resetDateToMidnight = (date: Date) => {
  const resetDate = new Date(date);
  resetDate.setHours(0, 0, 0, 0);
  return resetDate;
};

export const getLastFriday = (today: Date) => {
    const current = new Date(today);
    const dayOfWeek = current.getDay();
    
    // Si on est vendredi-jeudi (5,6,0,1,2,3,4), revenir au vendredi de la semaine précédente
    let daysBack;
    if (dayOfWeek === 5) {
      // Vendredi actuel → revenir à 7 jours (vendredi précédent)
      daysBack = 7;
    } else if (dayOfWeek === 6) {
      // Samedi → revenir à 8 jours (vendredi d'avant)
      daysBack = 8;
    } else if (dayOfWeek === 0) {
      // Dimanche → revenir à 9 jours (vendredi d'avant)
      daysBack = 9;
    } else {
      // Lundi-jeudi (1-4) → revenir au vendredi de la semaine précédente
      daysBack = dayOfWeek + 2 + 7;
    }
    
    const lastFriday = new Date(current);
    lastFriday.setDate(current.getDate() - daysBack);
    lastFriday.setHours(0, 0, 0, 0);
    return lastFriday;
  };

export const resetToFriday = (date: Date): Date => {
  const day = date.getDay();
  const diff = (5 - day + 7) % 7;
  const adjusted = new Date(date);
  adjusted.setDate(adjusted.getDate() + diff);
  adjusted.setHours(0, 0, 0, 0);
  return adjusted;
};

export const getNextPeriod = (date: Date) : Date => {
  const day = date.getDay();

  if(day === 5) 
    return addDaysToDate(date, 7); // Vendredi -> ajouter une semaine à la date pour arriver à la prochaine période
  else { // Sinon, remettre la date au vendredi
    return resetToFriday(date);
  }
}